export default __webpack_public_path__ + "static/media/img-65.b604f498.jpg";